import { useConfigStore } from '@/client/services/state/configStore';

export const useGetPublicImage = () => {
  const { config } = useConfigStore();
  const { publicImageUrl } = config;

  const getPublicImage = (path: string) => `${publicImageUrl}${path}`;

  return { getPublicImage };
};
